export class CurrencyHelper {
  static formatCurrency = (
    amount: number,
    isFormatted = true,
    locale = "fr-FR",
    currency = "EUR",
    minimumFractionDigits = 0,
  ): string => {
    if (!isFormatted) {
      return `${amount}`;
    }
    return (amount / 100).toLocaleString(locale, {
      style: "currency",
      currency,
      minimumFractionDigits,
    });
  };
}
